import { Flex } from '../../flayr-components/Flex/Flex';
import React from 'react';
import ArrayMap from '../../lib/ArrayMap/ArrayMap';
import Scroller from '../../lib/Scroller/Scroller';
import SingularOrPluralText from '../../lib/SingularOrPluralText/SingularOrPluralText';
import ProviderProfileCollapseContainer from '../../pages/customerPages/ProviderProfilePage/ProviderProfileCollapseContainer/ProviderProfileCollapseContainer';
import { ITestimonial } from '../../types/testimonial';
import TestimonialItem from '../TestimonialItem/TestimonialItem';

interface IProviderProfileTestimonialsSectionProps {
  testimonials?: ITestimonial[];
}

const ProviderProfileTestimonialsSection: React.FC<React.PropsWithChildren<React.PropsWithChildren<IProviderProfileTestimonialsSectionProps>>> =
  ({ testimonials = [] }) => {
    return (
      <ProviderProfileCollapseContainer
        hideIcon
        disabled
        open
        title={
          <>
            Testimonials ({testimonials.length}{' '}
            <SingularOrPluralText text="review" number={testimonials.length} />)
          </>
        }
      >
        <Scroller innerContainerClassName="pl-2 pb-4">
          <ArrayMap
            items={testimonials}
            keyField="id"
            render={(item: ITestimonial) => (
              <TestimonialItem
                className="self-stretch flex-none w-11/12 mr-4 text-gray-700"
                item={item}
              />
            )}
          />
        </Scroller>
      </ProviderProfileCollapseContainer>
    );
  };
export default ProviderProfileTestimonialsSection;
